module.exports = __webpack_public_path__ + "img/18.8abcf903.jpg";